import { useContext } from 'react'
import { PeekabooContext } from './PeekabooProvider'

export type PeekabooExperiment = {
  key: string
  variation: {
    key: string
  }
}

export type Peekaboo = {
  status: 'pending' | 'ready' | 'error'
  experiments: Array<PeekabooExperiment>
}

const usePeekaboo = (): Peekaboo => {
  return useContext(PeekabooContext)
}

export default usePeekaboo
